import {useSubIssuesSummary} from '@github-ui/sub-issues/useSubIssuesSummary'
import {Tooltip} from '@primer/react/deprecated'
import {graphql, useFragment} from 'react-relay'

import type {SubIssuesSummary$key} from './__generated__/SubIssuesSummary.graphql'
import styles from './SubIssuesSummary.module.css'
import type {SubIssueCompletionTokenProps} from './SubIssuesSummaryToken'
import {SubIssuesSummaryToken} from './SubIssuesSummaryToken'

interface SubIssueSummaryProps {
  issue: SubIssuesSummary$key
  onSummaryClick?: (event: React.MouseEvent, issueNode: {url: string} & unknown) => void
}

export function SubIssuesSummary({issue, onSummaryClick}: SubIssueSummaryProps) {
  const data = useFragment(
    // eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-queries
    graphql`
      fragment SubIssuesSummary on Issue {
        url
        ...useSubIssuesSummary @arguments(fetchSubIssues: false)
      }
    `,
    issue,
  )

  const progress = useSubIssuesSummary(data)

  const anchorAttrs: Partial<SubIssueCompletionTokenProps> | undefined = onSummaryClick && {
    as: 'a',
    href: data.url,
    onClick: e => onSummaryClick(e, data),
  }

  return progress.total > 0 ? (
    <div className={styles.summaryContainer}>
      <Tooltip aria-label={`${progress.percentCompleted}% completed`}>
        <SubIssuesSummaryToken {...anchorAttrs} progress={progress} />
      </Tooltip>
    </div>
  ) : null
}
